var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "flowNo",
                    expression: "'flowNo'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("flowNo"),
                  rules: _vm.getRules("flowNo"),
                  label: "编号",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.formData.flowNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "flowNo", $$v)
                  },
                  expression: "formData.flowNo",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "lzyg",
                    expression: "'lzyg'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("lzyg"),
                  name: "flowName",
                  label: "离职员工",
                  placeholder: "离职员工",
                  "input-align": "right",
                  rules: _vm.getRules("lzyg"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            treeData: _vm.deptUserTreeAll.data,
                            value: _vm.formData.lzyg,
                            placeholder: "请选择离职员工",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.deptUserTreeAll,
                                "lzyg"
                              )
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.deptUserTreeAll.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                              },
                              expression: "deptUserTreeAll.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择离职员工",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.deptUserTreeAll.show = false
                                },
                                "click-right": _vm.handlePopupSubmit,
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.treeSearch($event, _vm.$refs.tree)
                                },
                              },
                              model: {
                                value: _vm.deptUserTreeAll.filterText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.deptUserTreeAll,
                                    "filterText",
                                    $$v
                                  )
                                },
                                expression: "deptUserTreeAll.filterText",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "h-vh-35",
                                staticStyle: { "overflow-y": "auto" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "p-10" },
                                  [
                                    _c("el-tree", {
                                      ref: "tree",
                                      attrs: {
                                        "node-key": "uuid",
                                        "check-strictly": "",
                                        data: _vm.deptUserTreeAll.data,
                                        "filter-node-method": _vm.filterNode,
                                        "check-on-click-node": "",
                                        "show-checkbox": "",
                                      },
                                      on: {
                                        "check-change": function ($event) {
                                          return _vm.singleChoice(
                                            $event,
                                            _vm.$refs.tree
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.lzyg,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "lzyg", $$v)
                  },
                  expression: "formData.lzyg",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssbm",
                    expression: "'ssbm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssbm",
                  required: _vm.isRequired("ssbm"),
                  value: _vm.formData.ssbm,
                  label: "部门",
                  rules: _vm.getRules("ssbm"),
                  placeholder: "请选择部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssbm,
                            placeholder: "请选择部门",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssbm, "ssbm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssbm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssbm, "show", $$v)
                              },
                              expression: "ssbm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择部门",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssbm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ssbm", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssbm,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssbm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssbm, "filterText", $$v)
                                },
                                expression: "ssbm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssbm",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ssbm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssbm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-notice-bar", {
                attrs: {
                  scrollable: "",
                  text: "为避免影响系统正常使用，请在填写离职日期时务必谨慎。您可在流程的最终步骤再次确认具体的离职时间。一旦流程完成，系统将在您设定的离职日期自动更新您的离职状态。",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "lzrq",
                    expression: "'lzrq'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("lzrq"),
                  name: "lzrq",
                  label: "离职日期",
                  placeholder: "离职日期",
                  "input-align": "right",
                  rules: _vm.getRules("lzrq"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.lzrq,
                            placeholder: "请选择离职日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.lzrq, "lzrq")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "lzrq",
                          attrs: {
                            "min-date": _vm.minDate,
                            "show-confirm": false,
                            title: "选择离职日期",
                          },
                          on: { confirm: _vm.lzrqConfirm },
                          model: {
                            value: _vm.lzrq.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.lzrq, "show", $$v)
                            },
                            expression: "lzrq.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.lzrq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "lzrq", $$v)
                  },
                  expression: "formData.lzrq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sy",
                    expression: "'sy'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "sy",
                  required: _vm.isRequired("sy"),
                  rules: _vm.getRules("sy"),
                  value: _vm.formData.sy,
                  label: "离职原因",
                  placeholder: "请选择离职原因",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.sy,
                            placeholder: "请选择离职原因",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.sy, "sy")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.sy.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.sy, "show", $$v)
                              },
                              expression: "sy.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择离职原因",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.sy.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("sy")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.sy)
                                },
                              },
                              model: {
                                value: _vm.sy.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sy, "filterText", $$v)
                                },
                                expression: "sy.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "sy",
                              attrs: { columns: _vm.sy.filteredData },
                              on: {
                                cancel: function ($event) {
                                  _vm.sy.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bz",
                    expression: "'bz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("bz"),
                  required: _vm.isRequired("bz"),
                  rules: _vm.getRules("bz"),
                  name: "bz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.bz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bz", $$v)
                  },
                  expression: "formData.bz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "czsqfj",
                    expression: "'czsqfj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "czsqfj",
                  required: _vm.isRequired("czsqfj"),
                  rules: _vm.getRules("czsqfj"),
                  label: "辞职申请（签字）",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.czsqfj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("czsqfj"),
                            files: _vm.formData.czsqfj,
                            "module-type": "flow",
                          },
                          on: {
                            success: (fileList) => {
                              _vm.uploadSuccess(fileList, "czsqfj")
                            },
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "czsqfj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "jjbfj",
                    expression: "'jjbfj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "jjbfj",
                  required: _vm.isRequired("jjbfj"),
                  rules: _vm.getRules("jjbfj"),
                  label: "交接表（双方签字）",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.jjbfj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("jjbfj"),
                            files: _vm.formData.jjbfj,
                            "module-type": "flow",
                          },
                          on: {
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "jjbfj"
                              ),
                            success: (fileList) => {
                              _vm.uploadSuccess(fileList, "jjbfj")
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qtfj",
                    expression: "'qtfj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "qtfj",
                  required: _vm.isRequired("qtfj"),
                  rules: _vm.getRules("qtfj"),
                  label: "其他附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.qtfj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("qtfj"),
                            files: _vm.formData.qtfj,
                            "module-type": "flow",
                          },
                          on: {
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "qtfj"
                              ),
                            success: (fileList) => {
                              _vm.uploadSuccess(fileList, "qtfj")
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
            _vm._v("交接内容"),
          ]),
          _vm._l(_vm.formData.jjnr, function (item, index) {
            return _c(
              "van-cell-group",
              { key: index, staticClass: "m-t-20" },
              [
                _c(
                  "div",
                  {
                    staticClass: "p-b-20",
                    staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                  },
                  [
                    _c(
                      "van-row",
                      { attrs: { type: "flex", align: "center" } },
                      [
                        _c("van-col", { attrs: { span: 22 } }, [
                          _c("img", {
                            staticClass: "w-5 h-28",
                            attrs: {
                              src: `${_vm.image_base_url}/icon_line.png`,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "cor-33 font-weight-500 font-28 m-l-16",
                            },
                            [_vm._v(_vm._s(`明细${index + 1}`))]
                          ),
                        ]),
                        _vm.isShowIcon("jjnr")
                          ? _c(
                              "van-col",
                              {
                                attrs: { span: 2 },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "jjnr")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "nr",
                      expression: "'nr'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("nr"),
                    required: _vm.isRequired("nr"),
                    rules: _vm.getRules("nr"),
                    name: "nr",
                    type: "textarea",
                    maxlength: "200",
                    rows: "3",
                    autosize: "",
                    label: "内容",
                    "show-word-limit": "",
                    placeholder: "请输入内容",
                    "input-align": "right",
                  },
                  model: {
                    value: item.nr,
                    callback: function ($$v) {
                      _vm.$set(item, "nr", $$v)
                    },
                    expression: "item.nr",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "jjxs",
                      expression: "'jjxs'",
                    },
                  ],
                  attrs: {
                    "input-align": "right",
                    name: "jjxs",
                    required: _vm.isRequired("jjxs"),
                    rules: _vm.getRules("jjxs"),
                    value: _vm.formData.jjxs,
                    label: "交接形式",
                    placeholder: "请选择交接形式",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _vm.isDisabled("jjxs")
                              ? _c("div", [_vm._v(_vm._s(item.jjxs.join(",")))])
                              : _c(
                                  "van-checkbox-group",
                                  {
                                    attrs: {
                                      "checked-color": "#FFDA3E",
                                      direction: "horizontal",
                                    },
                                    model: {
                                      value: item.jjxs,
                                      callback: function ($$v) {
                                        _vm.$set(item, "jjxs", $$v)
                                      },
                                      expression: "item.jjxs",
                                    },
                                  },
                                  [
                                    _c(
                                      "van-checkbox",
                                      {
                                        attrs: {
                                          shape: "square",
                                          name: "电子",
                                        },
                                      },
                                      [_vm._v("电子")]
                                    ),
                                    _c(
                                      "van-checkbox",
                                      {
                                        attrs: {
                                          shape: "square",
                                          name: "书面",
                                        },
                                      },
                                      [_vm._v("书面")]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "jjry",
                      expression: "'jjry'",
                    },
                  ],
                  attrs: {
                    name: "jjry",
                    required: _vm.isRequired("jjry"),
                    rules: _vm.getRules("jjry"),
                    label: "接收人",
                    placeholder: "接收人",
                    "input-align": "right",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                treeData: _vm.deptUserTreeAll.data,
                                value: item.jjry,
                                placeholder: "请选择接收人",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.jjry.show,
                                    index,
                                    "jjry"
                                  )
                                },
                              },
                            }),
                            _c(
                              "van-popup",
                              {
                                attrs: { position: "bottom" },
                                model: {
                                  value: _vm.jjry.show[index],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.jjry.show, index, $$v)
                                  },
                                  expression: "jjry.show[index]",
                                },
                              },
                              [
                                _c("van-nav-bar", {
                                  attrs: {
                                    title: "选择接收人",
                                    "left-text": "取消",
                                    "right-text": "确定",
                                  },
                                  on: {
                                    "click-left": function ($event) {
                                      return _vm.popupHidden(
                                        _vm.jjry.show,
                                        index
                                      )
                                    },
                                    "click-right": function ($event) {
                                      return _vm.jjryPopupSubmit(item, index)
                                    },
                                  },
                                }),
                                _c("van-search", {
                                  attrs: { clearable: "", shape: "round" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.treeSearch(
                                        $event,
                                        _vm.$refs[`jjryTree_${index}`]
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.jjry.filterText[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.jjry.filterText, index, $$v)
                                    },
                                    expression: "jjry.filterText[index]",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "h-vh-35",
                                    staticStyle: { "overflow-y": "auto" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "p-10" },
                                      [
                                        _c("el-tree", {
                                          ref: `jjryTree_${index}`,
                                          refInFor: true,
                                          attrs: {
                                            "node-key": "uuid",
                                            "check-strictly": "",
                                            data: _vm.jjry.data,
                                            "filter-node-method":
                                              _vm.filterNode,
                                            "check-on-click-node": "",
                                            "show-checkbox": "",
                                          },
                                          on: {
                                            "check-change": function ($event) {
                                              return _vm.singleChoice(
                                                $event,
                                                _vm.$refs[`jjryTree_${index}`],
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: item.jjry,
                    callback: function ($$v) {
                      _vm.$set(item, "jjry", $$v)
                    },
                    expression: "item.jjry",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "sm",
                      expression: "'sm'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("sm"),
                    required: _vm.isRequired("sm"),
                    rules: _vm.getRules("sm"),
                    name: "sm",
                    type: "textarea",
                    maxlength: "200",
                    rows: "3",
                    autosize: "",
                    label: "说明",
                    "show-word-limit": "",
                    placeholder: "请输入说明",
                    "input-align": "right",
                  },
                  model: {
                    value: item.sm,
                    callback: function ($$v) {
                      _vm.$set(item, "sm", $$v)
                    },
                    expression: "item.sm",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "sfjj",
                      expression: "'sfjj'",
                    },
                  ],
                  attrs: {
                    "input-align": "right",
                    name: "sfjj",
                    required: _vm.isRequired("sfjj"),
                    rules: _vm.getRules("sfjj"),
                    value: _vm.formData.sfjj,
                    label: "是否交接",
                    placeholder: "请选择是否交接",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _vm.isDisabled("sfjj")
                              ? _c("view-item", { attrs: { value: item.sfjj } })
                              : _c(
                                  "van-radio-group",
                                  {
                                    attrs: {
                                      "checked-color": "#FFDA3E",
                                      direction: "horizontal",
                                    },
                                    model: {
                                      value: item.sfjj,
                                      callback: function ($$v) {
                                        _vm.$set(item, "sfjj", $$v)
                                      },
                                      expression: "item.sfjj",
                                    },
                                  },
                                  [
                                    _c("van-radio", { attrs: { name: "是" } }, [
                                      _vm._v("是"),
                                    ]),
                                    _c("van-radio", { attrs: { name: "否" } }, [
                                      _vm._v("否"),
                                    ]),
                                  ],
                                  1
                                ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            )
          }),
          !_vm.isDisabled("zffsmxb")
            ? _c(
                "van-row",
                [
                  _c("van-col", { attrs: { span: 12 } }),
                  _c(
                    "van-col",
                    { attrs: { span: 12 } },
                    [
                      _c("van-button", {
                        staticClass: "width-100",
                        attrs: {
                          icon: "add-o",
                          round: "",
                          "native-type": "button",
                          color: "#FFDA3E",
                          text: "添加交接内容",
                        },
                        on: { click: _vm.addItem },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qjqk",
                    expression: "'qjqk'",
                  },
                ],
                staticClass: "font-32 font-weight-500 cor-00 m-t-26",
              },
              [_vm._v("考勤情况")]
            ),
            _c(
              "van-cell-group",
              {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qjqk",
                    expression: "'qjqk'",
                  },
                ],
                staticClass: "m-t-20",
              },
              [
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "qjqk",
                      expression: "'qjqk'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("qjqk"),
                    required: _vm.isRequired("qjqk"),
                    rules: _vm.getRules("qjqk"),
                    name: "qjqk",
                    type: "textarea",
                    maxlength: "200",
                    rows: "3",
                    autosize: "",
                    label: "请假情况",
                    "show-word-limit": "",
                    placeholder: "请输入请假情况",
                    "input-align": "right",
                  },
                  model: {
                    value: _vm.formData.qjqk,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "qjqk", $$v)
                    },
                    expression: "formData.qjqk",
                  },
                }),
                !_vm.isDisabled("qjqk")
                  ? _c(
                      "van-row",
                      [
                        _c("van-col", { attrs: { span: 12 } }),
                        _c(
                          "van-col",
                          { attrs: { span: 12 } },
                          [
                            _c("van-button", {
                              staticClass: "width-100",
                              attrs: {
                                "native-type": "button",
                                color: "#FFDA3E",
                                text: "获取请假记录",
                              },
                              on: { click: _vm.getLeaveInfo },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "van-cell-group",
              {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "dkqk",
                    expression: "'dkqk'",
                  },
                ],
                staticClass: "m-t-20",
              },
              [
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "dkqk",
                      expression: "'dkqk'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("dkqk"),
                    required: _vm.isRequired("dkqk"),
                    rules: _vm.getRules("dkqk"),
                    name: "dkqk",
                    type: "textarea",
                    maxlength: "200",
                    rows: "3",
                    autosize: "",
                    label: "打卡情况",
                    "show-word-limit": "",
                    placeholder: "请输入打卡情况",
                    "input-align": "right",
                  },
                  model: {
                    value: _vm.formData.dkqk,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "dkqk", $$v)
                    },
                    expression: "formData.dkqk",
                  },
                }),
                !_vm.isDisabled("dkqk")
                  ? _c(
                      "van-row",
                      [
                        _c("van-col", { attrs: { span: 12 } }),
                        _c(
                          "van-col",
                          { attrs: { span: 12 } },
                          [
                            _c("van-button", {
                              staticClass: "width-100",
                              attrs: {
                                "native-type": "button",
                                color: "#FFDA3E",
                                text: "获取打卡记录",
                              },
                              on: { click: _vm.getCheckInInfo },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "gzjzrq",
                  expression: "'gzjzrq'",
                },
              ],
              staticClass: "font-32 font-weight-500 cor-00 m-t-26",
            },
            [_vm._v("五险一金及薪资结算")]
          ),
          _c(
            "van-cell-group",
            { staticClass: "m-t-20" },
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "gzjzrq",
                    expression: "'gzjzrq'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("gzjzrq"),
                  name: "gzjzrq",
                  label: "工资截止日期",
                  placeholder: "工资截止日期",
                  "input-align": "right",
                  rules: _vm.getRules("gzjzrq"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.gzjzrq,
                            placeholder: "请选择工资截止日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.gzjzrq, "gzjzrq")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "gzjzrq",
                          attrs: {
                            "min-date": _vm.minDate,
                            "show-confirm": false,
                            title: "选择工资截止日期",
                          },
                          on: { confirm: _vm.gzjzrqConfirm },
                          model: {
                            value: _vm.gzjzrq.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.gzjzrq, "show", $$v)
                            },
                            expression: "gzjzrq.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.gzjzrq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "gzjzrq", $$v)
                  },
                  expression: "formData.gzjzrq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sbzhjnyf",
                    expression: "'sbzhjnyf'",
                  },
                ],
                attrs: {
                  value: _vm.formData.sbzhjnyf[1],
                  required: _vm.isRequired("sbzhjnyf"),
                  name: "sbzhjnyf",
                  label: "社保截止月份",
                  placeholder: "社保截止月份",
                  "input-align": "right",
                  rules: _vm.getRules("sbzhjnyf"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.sbzhjnyf,
                            placeholder: "社保截止月份",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.sbzhjnyf, "sbzhjnyf")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.sbzhjnyf.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.sbzhjnyf, "show", $$v)
                              },
                              expression: "sbzhjnyf.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择社保截止月份",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.sbzhjnyf.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.sbzhjnyfChange("sbzhjnyf")
                                },
                              },
                            }),
                            _c("van-datetime-picker", {
                              ref: "sbzhjnyf",
                              attrs: {
                                "show-toolbar": false,
                                type: "year-month",
                                title: "选择月份",
                                "min-date": _vm.sbzhjnyf.minDate,
                                "max-date": _vm.sbzhjnyf.maxDate,
                              },
                              model: {
                                value: _vm.sbzhjnyf.currentDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sbzhjnyf, "currentDate", $$v)
                                },
                                expression: "sbzhjnyf.currentDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "gjjzhjnyf",
                    expression: "'gjjzhjnyf'",
                  },
                ],
                attrs: {
                  value: _vm.formData.gjjzhjnyf[1],
                  required: _vm.isRequired("gjjzhjnyf"),
                  name: "gjjzhjnyf",
                  label: "公积金截止月份",
                  placeholder: "公积金截止月份",
                  "input-align": "right",
                  rules: _vm.getRules("gjjzhjnyf"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.gjjzhjnyf,
                            placeholder: "公积金截止月份",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.gjjzhjnyf, "gjjzhjnyf")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.gjjzhjnyf.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.gjjzhjnyf, "show", $$v)
                              },
                              expression: "gjjzhjnyf.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择公积金截止月份",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.gjjzhjnyf.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.gjjzhjnyfChange("gjjzhjnyf")
                                },
                              },
                            }),
                            _c("van-datetime-picker", {
                              ref: "gjjzhjnyf",
                              attrs: {
                                "show-toolbar": false,
                                type: "year-month",
                                title: "选择月份",
                                "min-date": _vm.gjjzhjnyf.minDate,
                                "max-date": _vm.gjjzhjnyf.maxDate,
                              },
                              model: {
                                value: _vm.gjjzhjnyf.currentDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.gjjzhjnyf, "currentDate", $$v)
                                },
                                expression: "gjjzhjnyf.currentDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qtsm",
                    expression: "'qtsm'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("qtsm"),
                  required: _vm.isRequired("qtsm"),
                  rules: _vm.getRules("qtsm"),
                  name: "qtsm",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "其他说明",
                  "show-word-limit": "",
                  placeholder: "请输入其他说明",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.qtsm,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "qtsm", $$v)
                  },
                  expression: "formData.qtsm",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "sfyqk",
                  expression: "'sfyqk'",
                },
              ],
              staticClass: "font-32 font-weight-500 cor-00 m-t-26",
            },
            [_vm._v("财务确认")]
          ),
          _c(
            "van-cell-group",
            { staticClass: "m-t-20" },
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sfyqk",
                    expression: "'sfyqk'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "sfyqk",
                  required: _vm.isRequired("sfyqk"),
                  rules: _vm.getRules("sfyqk"),
                  value: _vm.formData.sfyqk,
                  label: "是否有欠款",
                  placeholder: "请选择是否有欠款",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _vm.isDisabled("sfyqk")
                          ? _c("view-item", {
                              attrs: { value: _vm.formData.sfyqk },
                            })
                          : _c(
                              "van-radio-group",
                              {
                                attrs: {
                                  "checked-color": "#FFDA3E",
                                  direction: "horizontal",
                                },
                                model: {
                                  value: _vm.formData.sfyqk,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "sfyqk", $$v)
                                  },
                                  expression: "formData.sfyqk",
                                },
                              },
                              [
                                _c("van-radio", { attrs: { name: "是" } }, [
                                  _vm._v("是"),
                                ]),
                                _c("van-radio", { attrs: { name: "否" } }, [
                                  _vm._v("否"),
                                ]),
                              ],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bxsfjq",
                    expression: "'bxsfjq'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "bxsfjq",
                  required: _vm.isRequired("bxsfjq"),
                  rules: _vm.getRules("bxsfjq"),
                  value: _vm.formData.bxsfjq,
                  label: "报销是否结清",
                  placeholder: "请选择报销是否结清",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _vm.isDisabled("bxsfjq")
                          ? _c("view-item", {
                              attrs: { value: _vm.formData.bxsfjq },
                            })
                          : _c(
                              "van-radio-group",
                              {
                                attrs: {
                                  "checked-color": "#FFDA3E",
                                  direction: "horizontal",
                                },
                                model: {
                                  value: _vm.formData.bxsfjq,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "bxsfjq", $$v)
                                  },
                                  expression: "formData.bxsfjq",
                                },
                              },
                              [
                                _c("van-radio", { attrs: { name: "是" } }, [
                                  _vm._v("是"),
                                ]),
                                _c("van-radio", { attrs: { name: "否" } }, [
                                  _vm._v("否"),
                                ]),
                              ],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
            _vm._v("流程"),
          ]),
          !_vm.$route.query.reSend &&
          (_vm.processInstanceId || _vm.$route.query.processInstanceId)
            ? _c("flowTrace", {
                staticClass: "m-t-20",
                attrs: {
                  flowTraceList: _vm.flowTrace,
                  processInfo: _vm.processData,
                },
              })
            : _c("approver", {
                ref: "approver",
                staticClass: "m-t-20",
                attrs: { processData: _vm.processData, formData: _vm.formData },
                on: { addUser: _vm.addUser },
              }),
          _c("bottom-bar", {
            on: { submit: _vm.submit, mention: _vm.mention },
          }),
          _c(
            "van-popup",
            {
              attrs: { position: "bottom" },
              model: {
                value: _vm.approver.show,
                callback: function ($$v) {
                  _vm.$set(_vm.approver, "show", $$v)
                },
                expression: "approver.show",
              },
            },
            [
              _c("van-nav-bar", {
                attrs: {
                  title: "选择办理人",
                  "left-text": "取消",
                  "right-text": "确定",
                },
                on: {
                  "click-left": function ($event) {
                    _vm.approver.show = false
                  },
                  "click-right": _vm.approverPopupSubmit,
                },
              }),
              _c("van-search", {
                attrs: { clearable: "", shape: "round" },
                on: {
                  input: function ($event) {
                    return _vm.treeSearch($event, _vm.$refs.approverTree)
                  },
                },
                model: {
                  value: _vm.approver.filterText,
                  callback: function ($$v) {
                    _vm.$set(_vm.approver, "filterText", $$v)
                  },
                  expression: "approver.filterText",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "h-vh-50",
                  staticStyle: { "overflow-y": "auto" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "p-10" },
                    [
                      _c("el-tree", {
                        ref: "approverTree",
                        attrs: {
                          "node-key": "uuid",
                          "check-strictly": "",
                          data: _vm.approver.data,
                          "filter-node-method": _vm.filterNode,
                          "check-on-click-node": "",
                          "show-checkbox": "",
                        },
                        on: {
                          "check-change": function ($event) {
                            return _vm.approverCheckChange(
                              $event,
                              _vm.$refs.approverTree
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }